module.exports = __webpack_public_path__ + "static/media/delete.ef124b18.svg";